import { render, staticRenderFns } from "./PublicPaap.vue?vue&type=template&id=0b2531c3"
import script from "./PublicPaap.vue?vue&type=script&lang=js"
export * from "./PublicPaap.vue?vue&type=script&lang=js"
import style0 from "./PublicPaap.vue?vue&type=style&index=0&id=0b2531c3&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports